import React, { Component } from 'react';
import { Col, Grid, Row, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import { MASTER_DASHBOARD_CHART_TYPE } from "../common/constants";

const printSet = {
    labels: ['1 Day', '1 Week', '1 Month',
        '1 Year'],
    datasets: [
        {
            label: 'Prints Done',
            backgroundColor: 'rgba(75,192,192,1)',
            data: [0, 0, 0, 0]
        }
    ]
};

const printerSet = {
    labels: ['1 Day', '1 Week', '1 Month',
        '1 Year'],
    datasets: [
        {
            label: 'Active Printer',
            backgroundColor: '#CC0033',
            data: [0, 0, 0, 0]
        }
    ]
};

export default class PrintDataOverview extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        const { startTime, endTime, printAndPrinterData } = this.props;
        const { print, printer } = printAndPrinterData;
        const endDateDisplay = moment(endTime).format('MM/DD/YYYY');
        const duration = moment(endTime).diff(moment(startTime), "days");
        //remove redundant data to avoid misunderstand
        const oneYearAgo = moment(Number(endTime)).subtract(1, 'years').valueOf();
        const oneMonthAgo = moment(Number(endTime)).subtract(1, 'months').valueOf();
        const oneWeekAgo = moment(Number(endTime)).subtract(1, "weeks").valueOf();
        const oneDayAgo = moment(Number(endTime)).subtract(1, "days").valueOf();
        const isWithinTargetTimePoint = (source, target) => {
            return source - 1 > target;
        };
        const NA = 'N/A';
        if (isWithinTargetTimePoint(startTime, oneYearAgo)) {
            print.oneYearCount = NA;
            printer.oneYearCount = NA;
        }
        if (isWithinTargetTimePoint(startTime, oneMonthAgo)) {
            print.oneMonthCount = NA;
            printer.oneMonthCount = NA;
        }
        if (isWithinTargetTimePoint(startTime, oneWeekAgo)) {
            print.oneWeekCount = NA;
            printer.oneWeekCount = NA;
        }
        if (isWithinTargetTimePoint(startTime, oneDayAgo)) {
            print.oneDayCount = NA;
            printer.oneDayCount = NA;
        }
        const printData = [
            print.oneDayCount,
            print.oneWeekCount,
            print.oneMonthCount,
            print.oneYearCount,
        ];
        const printerData = [
            printer.oneDayCount,
            printer.oneWeekCount,
            printer.oneMonthCount,
            printer.oneYearCount
        ];
        printSet.datasets[0].data = printData;
        printerSet.datasets[0].data = printerData;

        return (
            <div>
                <Grid fluid={true} className='grid-content'>
                    <Row>
                        <Col lg={6} md={6} xs={12}>
                            <h2>
                                Print
                            </h2>
                            <h4>
                                Total <i>{print.totalCount}</i> Done over time periods ending on
                                <i> {endDateDisplay} ({duration} days)</i>
                            </h4>
                            <h5>
                                Number of print that were done over time periods according to date range selector
                            </h5>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Period</th>
                                    <th>Prints</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>1 Day</td>
                                    <td>{print.oneDayCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Week</td>
                                    <td>{print.oneWeekCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Month</td>
                                    <td>{print.oneMonthCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Year</td>
                                    <td>{print.oneYearCount}</td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col lg={6} md={6} xs={12}>
                            <Bar
                                data={printSet}
                                getElementAtEvent={element => {
                                    if (element.length === 0) {
                                        return
                                    }
                                    const index = element[0]._index;
                                    const label = element[0]._chart.data.labels[index];
                                    const value = element[0]._chart.data.datasets[0].data[index];
                                    let start;
                                    switch (label) {
                                        case printSet.labels[0]:
                                            start = oneDayAgo;
                                            break;
                                        case printSet.labels[1]:
                                            start = oneWeekAgo;
                                            break;
                                        case printSet.labels[2]:
                                            start = oneMonthAgo;
                                            break;
                                        case printSet.labels[3]:
                                            start = oneYearAgo;
                                            break;
                                    }
                                    this.props.handleChartsClick({
                                        chartType: MASTER_DASHBOARD_CHART_TYPE.PRINT_OVERVIEW,
                                        label,
                                        value,
                                        end: endTime,
                                        start
                                    })
                                }}
                                options={{
                                    title: {
                                        display: true,
                                        text: 'Prints Done',
                                        fontSize: 20
                                    },
                                    legend: {
                                        display: false,
                                        position: 'right'
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </Grid>
                <Grid fluid={true} className='grid-content'>
                    <Row>
                        <Col lg={6} md={6} xs={12}>
                            <h2>
                                Printer
                            </h2>
                            <h5>
                                Number of printers that were active over time periods according to date
                                range selector
                            </h5>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Period</th>
                                    <th>Printers</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>1 Day</td>
                                    <td>{printer.oneDayCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Week</td>
                                    <td>{printer.oneWeekCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Month</td>
                                    <td>{printer.oneMonthCount}</td>
                                </tr>
                                <tr>
                                    <td>1 Year</td>
                                    <td>{printer.oneYearCount}</td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col lg={6} md={6} xs={12}>
                            <Bar
                                data={printerSet}
                                options={{
                                    title: {
                                        display: true,
                                        text: 'Active Printers',
                                        fontSize: 20
                                    },
                                    legend: {
                                        display: false,
                                        position: 'right'
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-overview.js